//example actions
import*as actionTypes from'./actionTypes';export var setAuth=function setAuth(user){return{type:actionTypes.SET_AUTH,user:user};};export var clearAuth=function clearAuth(){return function(dispatch,getState){// clears the auth reducer
dispatch({type:actionTypes.CLEAR_AUTH});// clear any ct Settings
dispatch({type:actionTypes.CT_CLEAR});// clear any project data
dispatch({type:actionTypes.CLEAR_DATA});// clear project from dashboard
dispatch({type:actionTypes.LOAD_PROJECTS,projects:[]});};};export var showAuthDialog=function showAuthDialog(status){return{type:actionTypes.SHOW_AUTH_DIALOG,status:status};};export var hideAuthDialog=function hideAuthDialog(){return{type:actionTypes.HIDE_AUTH_DIALOG};};


//////////////////
// WEBPACK FOOTER
// ./src/store/actions/auth.js
// module id = 770
// module chunks = 29